import { render, staticRenderFns } from "./GeneralLeadger.vue?vue&type=template&id=aa898cee&"
import script from "./GeneralLeadger.vue?vue&type=script&lang=js&"
export * from "./GeneralLeadger.vue?vue&type=script&lang=js&"
import style0 from "./GeneralLeadger.vue?vue&type=style&index=0&id=aa898cee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports